<template>
  <div class="mask" v-if="visible" @click.self="closeDialog">
    <div class="dialog-wrap">
      <!-- 弹窗头部 -->
      <div class="dialog-header">
        <!-- 头部背景图 -->
        <img class="header-bg-img" :src="headerImgUrl" alt="头部背景">
        <div class="header-text-wrap">
            <h2>检验检测服务</h2>
            <span class="close" @click="closeDialog">×</span>
        </div>
      </div>
      <!-- 滚动内容区 -->
      <div class="dialog-body">
        <!-- 第一块：服务内容简介 -->
        <div class="block-box">
          <table class="intro-table">
            <tr>
              <td class="label-td">服务内容简介</td>
              <td class="text-td">
                陶瓷砖国家标准GB/T 4100所含全部检验项目的检测，出具国家级试验室CMA、CNAS双C认证检验检测报告；型式检验；3C认证项目：放射性核素限量的检测；适用其它国标的细分门类建陶产品（防静电瓷砖、耐酸砖、大规格陶瓷板等）的检测；防滑性、防火等级等适老康养类检验项目的检测；工艺论证性检测。
              </td>
            </tr>
            <tr>
              <td class="label-td">服务事项说明</td>
              <td class="text-td">联系人：陆亚楠；联系电话0533-2858021。</td>
            </tr>
          </table>
        </div>

        <!-- 第二块：服务内容清单主表格 -->
        <div class="table-scroll">
          <table class="main-table" border="1" cellpadding="8" cellspacing="0">
            <thead>
              <tr>
                <th>服务能力项名称</th>
                <th>依据的政策/标准/规范/规程编号</th>
                <th>依据的政策/标准/规范/规程名称</th>
                <th>范围/约束/限制/备注说明</th>
                <th>参考服务价格(元)</th>
                <th>预计服务周期</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in tableData" :key="idx">
                <td>{{ row.name }}</td>
                <td>{{ row.code }}</td>
                <td>{{ row.standardName }}</td>
                <td>{{ row.range }}</td>
                <td>{{ row.price }}</td>
                <td>{{ row.cycle }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InspectionTableDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 新增：头部背景图片地址
    headerImgUrl: {
        type: String,
        default: require('@/assets/img/buxiugang/dialog.png')
    }
  },
  data() {
    return {
      // 完整表格数据，和截图一一对应
      tableData: [
        {
          name: "尺寸等",
          code: "GB/T3 810.2-2016",
          standardName: "尺寸和表面质量的检验",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "吸水率等",
          code: "GB/T3 810.3-2016",
          standardName: "吸水率、显气孔率、表观相对密度和容重的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "破坏强度和断裂模数",
          code: "GB/T3 810.4-2016",
          standardName: "断裂模数和破坏强度的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "抗冲击性",
          code: "GB/T3 810.5-2016",
          standardName: "用恢复系数确定砖的抗冲击性",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "耐磨性",
          code: "GB/T3 810.6-2016+GB/T3 810.6-2016",
          standardName: "无釉砖耐磨深度的测定/有釉砖表面耐磨性的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "线性热膨胀",
          code: "GB/T3 810.8-2016",
          standardName: "线性热膨胀的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "抗热震性",
          code: "GB/T3 810.9-2016",
          standardName: "抗热震性的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "湿膨胀",
          code: "GB/T3 810.10-2016",
          standardName: "湿膨胀的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "抗釉裂性",
          code: "GB/T3 810.11-2016",
          standardName: "有釉砖抗釉裂性的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "抗冻性",
          code: "GB/T3 810.12-2016",
          standardName: "抗冻性的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "耐化学腐蚀性",
          code: "GB/T3 810.13-2016",
          standardName: "耐化学腐蚀性的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "耐污染性",
          code: "GB/T3 810.14-2016",
          standardName: "耐污染性的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "铅、镉溶出量",
          code: "GB/T3 810.15-2016",
          standardName: "有釉砖铅和镉溶出量的测定",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "放射性核素限量",
          code: "GB 6566-2010",
          standardName: "建筑材料放射性核素限量",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        },
        {
          name: "防滑性等级评价",
          code: "GB/T3 7798-2019",
          standardName: "陶瓷砖防滑性等级评价",
          range: "全部指标项",
          price: "面议",
          cycle: "15个工作日"
        }
      ]
    }
  },
  methods: {
    closeDialog() {
      this.$emit("update:visible", false);
      this.$emit("close");
    }
  }
}
</script>

<style scoped>
/* 遮罩层 */
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
}
/* 弹窗外层 */
.dialog-wrap {
  width: 100%;
  max-width: 1300px;
  max-height: 92vh;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
/* 弹窗头部 */
.dialog-header {
  position: relative;
  width: 100%;
  height: 95px;
  overflow: hidden;
}
/* 背景图铺满头部 */
.header-bg-img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  display: block;
}
/* 文字、关闭按钮容器，悬浮在图片上层 */
.header-text-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
}
.header-text-wrap h2 {
  margin: 0;
  font-size: 20px;
  color: #ffffff; /* 白色文字适配深色背景图，可自行修改 */
}
.close {
  font-size: 26px;
  color: #fff;
  cursor: pointer;
}
.close:hover {
  color: #ff6666;
}
/* 滚动内容区域 */
.dialog-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}
/* 简介模块 */
.block-box {
  margin-bottom: 20px;
}
.intro-table {
  width: 100%;
  border: 1px solid #999;
  border-collapse: collapse;
}
.intro-table td {
  border: 1px solid #999;
  padding: 10px 14px;
  font-size: 14px;
  line-height: 1.6;
}
.label-td {
  width: 140px;
  background: #f7f9fc;
  font-weight: 500;
}
.text-td {
  text-align: left;
}
/* 主表格横向滚动容器 */
.table-scroll {
  overflow-x: auto;
}
.main-table {
  min-width: 1100px;
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.main-table th,
.main-table td {
  border: 1px solid #333;
  text-align: center;
  line-height: 1.5;
}
.main-table th {
  background: #f0f4f9;
  font-weight: 600;
  white-space: nowrap;
}
</style>